import { createRouter } from '@tanstack/react-router';
import { buildAppRouteTree } from './buildAppRouteTree.jsx';

const routeTree = buildAppRouteTree();

/** Plain query strings — avoid TanStack's default JSON search (`verified=%221%22`). */
function stringifySearch(search) {
  const params = new URLSearchParams();
  Object.entries(search || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (typeof value === 'object') {
      params.set(key, JSON.stringify(value));
      return;
    }
    params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

function parseSearch(searchStr) {
  const raw = String(searchStr || '');
  const params = new URLSearchParams(raw.startsWith('?') ? raw.slice(1) : raw);
  const out = {};
  params.forEach((value, key) => {
    out[key] = value;
  });
  return out;
}

export const appRouter = createRouter({
  routeTree,
  defaultPreload: 'intent',
  stringifySearch,
  parseSearch,
});

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    appRouter.invalidate();
  });
}
